module.exports = __webpack_public_path__ + "img/customer-service.11e0aa69.svg";